// Note! Important thing about this file utils

// typo in window is intentional so it's not used by global window.
// Window object has to be provided by Angular, so it works
// consistently across all platforms / devices

export const getZoom = (wdw: Window | null) => {
  if (!wdw) return null;
  return Math.round(wdw.devicePixelRatio * 100);
};
